<template>
  <div>
    <TheHeader></TheHeader>
    <SharePriceBar />
    <PageHeader full>
      <TextHeading variant="xl">
        Listening and learning from
        <br />our customers
      </TextHeading>
    </PageHeader>
    <PageCarousel />
    <PageGrid>
      <PageMain>
        <PageSection title="Latest News">
          <Cards>
            <CardsCol>
              <CardArticle
                title="We are proud of all our fresh fish and seafood sold in our stores and café."
                image="carrier-bags.jpg"
                date="01 Jan 2019"
                aria="Read about We are proud of all our fresh fish and seafood sold in our stores and café."
              />
            </CardsCol>
            <CardsCol>
              <CardArticle
                title="Morrisons trials first plastic deposit return scheme in its supermarket."
                image="man-fish.jpg"
                date="12 Dec 2018"
                aria="Read about Morrisons trials first plastic deposit return scheme in its supermarket."
              />
            </CardsCol>
            <CardsCol>
              <CardArticle
                title="Morrisons trials first plastic deposit return scheme in its supermarket."
                image="farmer.jpg"
                date="30 Aug 2018"
                aria="Read about Morrisons trials first plastic deposit return scheme in its supermarket."
              />
            </CardsCol>
          </Cards>
        </PageSection>
        <PageSection>
          <PageInset columns="1">
            <PageQuotes
              quote="Our people are our most valuable asset and our success relies on our people delivering great service to our customers each and every day."
              author="David Potts, Chief Executive Officer"
              button="Read More"
            ></PageQuotes>
          </PageInset>
        </PageSection>
        <PageSection title="Investor Centre">
          <Cards>
            <CardsCol>
              <CardLink
                title="Q3 Trading Statement"
                link="Regulatory News"
                category="Announcements"
              ></CardLink>
            </CardsCol>
            <CardsCol>
              <CardLink
                title="Find out more about our upcoming events"
                link="View Calendar"
                category="Financial Calendar"
              ></CardLink>
            </CardsCol>
            <CardsCol>
              <CardLink
                title="Get an indicitive valuation of your shareholding"
                category="Shareholder Services"
              ></CardLink>
            </CardsCol>
          </Cards>
        </PageSection>
        <StatsBar />
        <PageSection title="Corporate Responsibility">
          <MainBanner />
        </PageSection>
        <PageSection title="Downloads">
          <Cards>
            <CardsCol>
              <CardDownload title="Full Annual Report 2018/2019" shape="oval" />
            </CardsCol>
            <CardsCol>
              <CardDownload
                title="Corporate Responsibility 2018/2019"
                shape="rectangle"
              />
            </CardsCol>
            <CardsCol>
              <CardDownload
                title="Strategic Report 2018/2019"
                shape="triangle"
              />
            </CardsCol>
          </Cards>
        </PageSection>
        <PageSection title="Useful Links">
          <Cards>
            <CardsCol>
              <CardLink
                title="Board Members Biographies"
                category="Leadership"
                image="andy-atkinson.png"
              ></CardLink>
            </CardsCol>
            <CardsCol>
              <CardLink
                title="Learn more about our history and key milestones that goes over three lines"
                category="Company Info"
              ></CardLink>
            </CardsCol>
            <CardsCol>
              <CardLink
                title="Official photos, logos and assets for download"
                category="Media Assets"
              ></CardLink>
            </CardsCol>
          </Cards>
        </PageSection>
      </PageMain>
    </PageGrid>
    <TheFooter></TheFooter>
  </div>
</template>

<script>
import CardsCol from '../elements/CardsCol.vue'
import TheFooter from '../components/TheFooter.vue'
import CardArticle from '../components/CardArticle.vue'
import CardDownload from '../components/CardDownload.vue'
import Cards from '../elements/Cards.vue'
import MainBanner from '../components/MainBanner.vue'
import StatsBar from '../components/StatsBar.vue'
import CardLink from '../components/CardLink.vue'
import PageQuotes from '../components/PageQuotes.vue'
import PageInset from '../elements/PageInset.vue'
import PageSection from '../elements/PageSection.vue'
import PageMain from '../elements/PageMain.vue'
import PageGrid from '../elements/PageGrid.vue'
import PageCarousel from '../components/PageCarousel.vue'
import TextHeading from '../elements/TextHeading.vue'
import PageHeader from '../components/PageHeader.vue'
import SharePriceBar from '../components/SharePriceBar.vue'
import TheHeader from '../components/TheHeader.vue'
export default {
  name: 'Home',
  components: {
    TheHeader,
    SharePriceBar,
    PageHeader,
    TextHeading,
    PageCarousel,
    PageGrid,
    PageMain,
    PageSection,
    PageInset,
    PageQuotes,
    Cards,
    CardLink,
    StatsBar,
    MainBanner,
    CardDownload,
    CardArticle,
    TheFooter,
    CardsCol
  },
  methods: {
    handleClick(url) {
      window.location.href = url
    }
  }
}
</script>
